import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'eurogard-hide-filter-row-button',
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
  ],
  templateUrl: './hide-filter-row-button.component.html',
  styleUrl: './hide-filter-row-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HideFilterRowButtonComponent {
  public readonly isFilterRowHidden = signal(false);

  protected toggleIsFilterRowHidden(): void {
    this.isFilterRowHidden.update((value) => !value);
  }
}
